module.exports = __webpack_public_path__ + "img/积分换金币.023efbec.png";